// extracted by mini-css-extract-plugin
export default {"userLabel":"UserLabel_styles_userLabel__-8TQ3","userName":"UserLabel_styles_userName__kIFwg"};